"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccountAsync = exports.getAccount = void 0;
const constants_1 = require("../utils/constants");
const helper_1 = require("../utils/helper");
const getAccount = () => {
    var _a, _b, _c;
    let newAccount = null;
    const triaC = (0, helper_1.triaConnected)();
    const wagmiC = (0, helper_1.wagmiConnected)();
    if (triaC) {
        const account = localStorage.getItem(constants_1.TRIA_WALLET_STORE);
        if (account) {
            newAccount = JSON.parse(account);
        }
    }
    else if (wagmiC) {
        const wagmiStore = localStorage.getItem('wagmi.store');
        if (wagmiStore) {
            newAccount = {
                triaName: null,
                evm: {
                    address: (_c = (_b = (_a = JSON.parse(wagmiStore)) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.account,
                },
            };
        }
    }
    return newAccount;
};
exports.getAccount = getAccount;
// not used rn anywhere
const getAccountAsync = () => __awaiter(void 0, void 0, void 0, function* () {
    let newAccount = null;
    const triaC = (0, helper_1.triaConnected)();
    const { isConnected, address } = yield (0, helper_1.wagmiConnectedAsync)();
    if (triaC) {
        const account = localStorage.getItem(constants_1.TRIA_WALLET_STORE);
        if (account) {
            newAccount = JSON.parse(account);
        }
    }
    else if (isConnected) {
        if (address) {
            newAccount = {
                triaName: null,
                evm: {
                    address,
                },
            };
        }
    }
    return newAccount;
});
exports.getAccountAsync = getAccountAsync;
